import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["addForm", "addButton", "contactRow", "editRow"]

  toggleAdd() {
    this.addFormTarget.classList.toggle("hidden")
    this.addButtonTarget.classList.toggle("hidden")
    if (!this.addFormTarget.classList.contains("hidden")) {
      this.addFormTarget.querySelector("input[name='client_contact[name]']")?.focus()
    }
  }

  cancelAdd() {
    this.addFormTarget.classList.add("hidden")
    this.addButtonTarget.classList.remove("hidden")
    this.addFormTarget.reset?.()
    // Reset form inputs manually, including the also-add multi-select: a
    // stale selection there would silently duplicate the NEXT contact onto
    // clients picked for the cancelled one.
    this.addFormTarget.querySelectorAll("input, textarea").forEach(el => { el.value = "" })
    this.addFormTarget.querySelectorAll("select").forEach(el => {
      Array.from(el.selectedOptions).forEach(opt => { opt.selected = false })
    })
  }

  edit(event) {
    const contactId = event.currentTarget.dataset.contactId
    const displayRow = this.contactRowTargets.find(r => r.dataset.contactId === contactId)
    const editRow = this.editRowTargets.find(r => r.dataset.contactId === contactId)
    if (displayRow) displayRow.classList.add("hidden")
    if (editRow) editRow.classList.remove("hidden")
  }

  cancelEdit(event) {
    const contactId = event.currentTarget.dataset.contactId
    const displayRow = this.contactRowTargets.find(r => r.dataset.contactId === contactId)
    const editRow = this.editRowTargets.find(r => r.dataset.contactId === contactId)
    if (displayRow) displayRow.classList.remove("hidden")
    if (editRow) editRow.classList.add("hidden")
  }

  async saveEdit(event) {
    event.preventDefault()
    // The form may be an empty CARRIER (edit page: inputs associate via the
    // form attribute); FormData still collects them, but error feedback
    // must flash the VISIBLE edit row, never the carrier.
    const form = event.currentTarget
    const contactId = form.dataset.contactId
    const visibleEditRow = this.editRowTargets.find(r => r.dataset.contactId === contactId)
    const url = form.action
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    const formData = new FormData(form)

    try {
      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "X-CSRF-Token": csrfToken,
          "Accept": "application/json"
        },
        body: formData
      })

      if (response.ok) {
        // The server decides what the person now looks like (a primary
        // swap exchanges numbers between the column and a row, and the
        // extras line and radios change with it), so the row is rebuilt
        // from the server rather than patched from the form. A patched
        // form would post the OLD primary back on its next save.
        window.Turbo ? window.Turbo.visit(window.location.href, { action: "replace" }) : window.location.reload()
      } else {
        this._flash(visibleEditRow, "bg-[#E57373]/10")
        // The server's sentence, in the row (a bare red flash says nothing).
        const err = visibleEditRow.querySelector("[data-field='error']")
        if (err) err.textContent = (await response.json().catch(() => ({}))).error || "Could not save."
      }
    } catch (error) {
      console.error("Failed to save contact:", error)
      this._flash(visibleEditRow, "bg-[#E57373]/10")
    }
  }

  _flash(element, colorClass) {
    if (!element) return
    element.classList.add(colorClass)
    setTimeout(() => element.classList.remove(colorClass), 1500)
  }
}
